<template>
  <ul class="share-btns">
    <li class="share-btns__item" v-for="(btn, i) in shareBtns" :key="i">
      <BaseSocialShare
        class="share-btns__link"
        :customClass="btn"
        @shareLink="onLinkShare"
      />
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      title: '',
      tabWidth: 600,
      tabHeight: 300,
      screenWidth: null,
      screenHeight: null,
      x: null,
      y: null
    }
  },
  props: {
    id: [String, Number],
    shareBtns: Array
  },
  computed: {
    ...mapGetters('data', ['URL']),
    link() {
      const link = this.$route.path.split('/').slice(1)[0]
      return link
    }
  },
  methods: {
    shareFacebook() {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          `${this.URL}/${this.link}/${this.id.toString()}`
        )}&t=${this.title}`,
        'pop',
        `left=${this.x},top=${
          this.y
        },menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=${
          this.tabHeight
        },width=${this.tabWidth}`
      )
    },

    shareTelegram() {
      window.open(
        'https://telegram.me/share/url?url=' +
          encodeURIComponent(`${this.URL}/${this.link}/${this.id.toString()}`),
        '_blank'
      )
    },

    onLinkShare({ btn }) {
      if (btn.classList.contains('btn-share--facebook')) {
        this.shareFacebook()
      } else if (btn.classList.contains('btn-share--telegram')) {
        this.shareTelegram()
      }
    }
  },
  mounted() {
    (this.title = document.title),
      (this.screenWidth = window.screen.width),
      (this.screenHeight = window.screen.height),
      (this.x = this.screenWidth / 2 - this.tabWidth / 2),
      (this.y = this.screenHeight / 2 - this.tabHeight / 2)
  }
}
</script>

<style lang="scss">
.share-btns {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;

  &__item {
    pointer-events: none;

    &:not(:last-of-type) {
      margin-right: 16px;
    }
  }

  &__link {
    pointer-events: all;
    transition: all 600ms cubic-bezier(0.68, -0.55, 0.265, 1.55);

    &:hover {
      transform: translateY(-13px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/SocialBtnsList.vue